<template>
    <div class="orders-container">
        <b-container>
            <b-row>
                <b-col cols="12" class="mb-4">
                    <h3>Ordenes</h3>
                </b-col> 
                <b-col md="3" class="mb-3">
                    <b-form-input id="input-11" v-model="filters.name.value" placeholder="Buscar" type="text"></b-form-input> 
                </b-col>
                <b-col md="9" cols="6" class="mb-3 text-right">
                    <div class="select-wrapper">
                        <single-select
                            v-model="hospital"
                            :options="optionsHospitals"
                            placeholder=""
                            :required="true"
                            :key="optionsHospitals.lenght"
                            :label="'Hospitales'"
                            class="select-hospital"
                            v-if="userAccessLevel == 'super'"
                        ></single-select>
                        <b-button v-on:click="downloadExcel" class="btn-download-excel">Descargar Excel</b-button>
                    </div>
                </b-col>
                <b-col cols="12">
                    <v-table
                        :data="orders"
                        :currentPage.sync="currentPage"
                        :pageSize="7"
                        :filters="filters"
                        @totalPagesChanged="totalPages = $event"
                        class="mb-3"
                    >
                        <thead slot="head">
                            <th defaultSort="desc">ID</th>
                            <th>Hospital</th>
                            <th>No. de Colaborador</th>
                            <th>Sub Configuración <br> de Puesto</th>
                            <th>Puesto</th>
                            <th>Modelos</th>
                            <th>Género</th>
                            <th></th>
                        </thead>
                        <tbody slot="body" slot-scope="{displayData}">
                            <tr v-for="row in displayData" :key="row.guid">
                                <td>{{ row.id }}</td>
                                <td>{{ row.hospital.name }}</td>
                                <td>{{ row.collaborator_number }}</td>
                                <td>{{ row.area.name }}</td>
                                <td>{{ row.position.name }}</td>
                                <td><strong>Filipina {{ row.scrub_model }}</strong> Talla: {{ row.scrub_size }} <span v-if="userAccessLevel == 'super'">Color: {{ row.scrub_color }}</span> <br>
                                    <span v-if="row.scrub_cap_qty!=0 && row.scrub_cap_model"><strong>Chamarras {{ row.scrub_cap_model }}</strong> Talla: {{ row.scrub_cap_size }} <span v-if="userAccessLevel == 'super'">Color:  {{ row.scrub_cap_color }}</span> <br></span>
                                    <strong>Pantalones {{ row.pants_model }}</strong>Talla: {{ row.pants_size }} <span v-if="userAccessLevel == 'super'">Color:  {{ row.pants_color }}</span> <br>
                                    <span v-if="row.coat_qty!=0 && row.coat_model"><strong>Bata {{ row.coat_model }}</strong> <span v-if="userAccessLevel == 'super'">Color:  {{ row.coat_color }}</span> <br></span>
                                    <span v-if="row.coat_qty2!=0 && row.coat_model2"><strong>Bata {{ row.coat_model2 }}</strong> Talla: {{ row.coat_size2 }}  <span v-if="userAccessLevel == 'super'">Color:  {{ row.coat_color2 }}</span> <br></span></td>
                                    <span v-if="row.overol_qty!=0 && row.overol_model"><strong>Overol {{ row.overol_model }}</strong> Talla: {{ row.overol_size }} <span v-if="userAccessLevel == 'super'">Color:  {{ row.overol_color }}</span> <br></span>
                                    <span v-if="row.shoes_qty!=0 && row.shoes_model"><strong>Calzado {{ row.shoes_model }}</strong> Talla: {{ row.shoes_size }} <span v-if="userAccessLevel == 'super'">Color:  {{ row.shoes_color }}</span> <br></span>
                                    
                                <td>{{ row.gender.name }}</td>
                                <td><router-link :to="{ name: 'EditOrder', params: { orderId: row.id}}" class="btn" v-if="userAccessLevel == 'super'">Editar</router-link></td>
                            </tr>
                        </tbody>
                    </v-table>
                    <smart-pagination
                        :currentPage.sync="currentPage"
                        :totalPages="totalPages"
                    />
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import axios from 'axios'
    import qs from 'qs'
    import SingleSelect from '../elements/SingleSelectHospital.vue'

    export default {
        created (){
            var token = sessionStorage.getItem('api_token'),
                id_user = sessionStorage.getItem('id_user'),
                is_admin = sessionStorage.getItem('is_admin'),
                user_hospital = JSON.parse(sessionStorage.getItem('user_hospital'))

            if (is_admin == 'no'){
                this.$router.push('/orden')
            }

            if (is_admin == 'yes'){
                let temp = []
                Object.keys(user_hospital).map((key) => [user_hospital[key]]).map(function(value) {
                    temp.push(value[0])
                })
                this.hospital = temp ? temp[0] : '' 
            }

            
            this.userAccessLevel = is_admin
            axios
            .post(
                'https://api-starmedica.domikuniformes.com/orders_api.php',
                qs.stringify({ 
                    api_token: token, 
                    user_id: id_user,
                    option: 'get_orders'
                }),
            )
            .then((response) => {
                if (!response.data.error.code) {
                    let temp = []
                    Object.keys(response.data.orders).map((key) => [response.data.orders[key]]).map(function(value) {
                        temp.push(value[0])
                    })
                    this.orders = temp.reverse()
                }
            })
            .catch((err) => {
                console.log(err)
            })

            axios
            .post(
                'https://api-starmedica.domikuniformes.com/orders_api.php',
                qs.stringify({ 
                    api_token: token, 
                    user_id: id_user,
                    option: 'get_catalogs',
                }),
            )
            .then((response) => {
                if (!response.data.error.code) {
                    var listHospitals = []
                    listHospitals.push({name:'Todos los hospitales', id: null })
                    Object.keys(response.data.hospitals).map((key) => [response.data.hospitals[key]]).map(function(value) {
                        listHospitals.push(value[0])
                    })
                    this.optionsHospitals = listHospitals
                }
            })
            .catch((err) => {
                console.log(err)
            })
        },
        methods: {
            async downloadExcel (){
                var token = sessionStorage.getItem('api_token')
                var id_user = sessionStorage.getItem('id_user')
                var url
                if( this.hospital.id ) { 
                    url = 'https://api-starmedica.domikuniformes.com/db_to_xlsx.php?hospital_id='+ this.hospital.id 
                } else{   
                    url = 'https://api-starmedica.domikuniformes.com/db_to_xlsx.php'
                }
                
                await axios
                .post(
                    url,
                    qs.stringify({
                        api_token: token,
                        user_id: id_user,
                    }),
                    {
                        responseType: 'arraybuffer',
                        headers: {
                            'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                            'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        }
                    }
                )
                .then(response => {
                    let blob = new Blob([response.data], { type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = 'ordenes.xlsx'
                    link.click()
                    window.URL.revokeObjectURL(blob)
                })
                .catch(err => {
                    console.log(err)
                })
            }
        },
        components: {
            SingleSelect
        },
        data() {
            return {
                orders: [],
                optionsHospitals: [],
                userAccessLevel: '',
                currentPage: 1,
                excelfile: '',
                totalPages: 0,
                hospital: '',
                filters: {
                    name: { value: '', keys: ['collaborator_number', 'name', 'first_lastname', 'second_lastname', 'hospital.name', 'area.name', 'position.name', 'gender.name'  ] }
                }
            }
        }
    }
</script>

<style scoped>
.orders-container{
    padding: 70px 5%;
}
table{
    width: 100%;
}
td{
    font-size: 13px;
    padding: 20px 10px 20px 0 !important;
}
.btn{
    font-size: 13px ;
}
.btn,
.btn:focus,
.btn:hover{
    background: #F15E1A;
    border: none;
    font-weight: normal;
    color: #fff;
}
.btn-download-excel{
    height: calc(2.5rem + 4px);
    margin-left: 10px;
}
.select-wrapper{
    display: inline-flex;
}
h3{
    font-weight: bold;
    font-size: 25px;
}

.text-right{
    text-align: right;
}
.select-hospital{
    min-width: 250px;
    max-width: 300px;
}
</style>